import i18n from "@/i18n/index.js";

export default {
    methods: {
        __errorLabelUpdate(noFromDate, noToDate) {
            let errorLabel = "";
            if (noFromDate) {
                errorLabel = i18n.t("admin.processInspector.errorFromDate");
            } else if (noToDate) {
                errorLabel = i18n.t("admin.processInspector.errorDate");
            }
            return errorLabel;
        },
        __setDocsBgColor(value) {
            let result = "background-color: #BF4AE2";
            let formattedValue = value.split(".");
            formattedValue = formattedValue[formattedValue.length - 1];
            const wordProcessorArray = [
                "doc",
                "docx",
                "odt",
                "pdf",
                "rtf",
                "tex",
                "txt",
                "wks",
                "wps",
                "wpd"
            ];
            const databaseFileArray = [
                "csv",
                "dat",
                "db",
                "dbf",
                "log",
                "mdb",
                "sav",
                "sql",
                "tar",
                "xml",
                "json"
            ];
            const imageFileArray = [
                "ai",
                "bmp",
                "gif",
                "ico",
                "jpeg",
                "jpg",
                "png",
                "ps",
                "psd",
                "svg",
                "tif",
                "tiff"
            ];
            if (wordProcessorArray.find(item => formattedValue === item)) {
                result = "background-color: #4285F4";
            } else if (databaseFileArray.find(item => formattedValue === item)) {
                result = "background-color: #07142C";
            } else if (imageFileArray.find(item => formattedValue === item)) {
                result = "background-color: #00CC66";
            }
            return result;
        }
    }
};
